import BaseComponent from "../../baseComponent.js";
import StudioCard from "./studioCard.jsx";
import styles from "./studios.scss";

export default class Studios extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let studios = this.props.studios.map((studio, index) => {
      return <div key={index} className="col-sm-6 col-md-4 col-lg-3 pannaramic-tile-wrapper">
        <StudioCard id={studio.id}
                    image={studio.image}
                    title={studio.title}
                    provider={studio.provider}
                    description={studio.description}
                    likeCounter={studio.likeCounter}
                    commentCounter={studio.commentCounter}
                    categories={studio.categories}/>
      </div>;
    });
    return (
      <div className={styles.container}>
        <div className={styles.studioCards}>
          {studios}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/analytic-studio/studios/studios.jsx